import { Component } from '@angular/core';

@Component({
  selector: 'mad-content-header',
  templateUrl: './content-header.component.html',
  styleUrls: ['./content-header.component.scss'],
  standalone: true,
})
export class ContentHeaderComponent {}
